const isValidClassName = (
	isShowValid: boolean | undefined,
	wrong: boolean | undefined,
	value: string | number | boolean | File | undefined,
	disabled: boolean | undefined
) => {
	if (isShowValid) {
		if (!!value) {
			return ''
		} else {
			if (disabled || wrong) {
				return 'is-invalid'
			} else {
				return 'is-valid'
			}
		}
	}

	return ''
}

export default isValidClassName
